import { styled } from "styled-components";

export const ModalContent = styled.div`
  position: relative;
  background-color: white;
  width: 300px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  color: #383838;
`;
